/**
 * API Configuration Helper
 * 
 * This module provides the correct API URL for both:
 * - Preview environment: Uses REACT_APP_BACKEND_URL
 * - Production with custom domain: Uses relative URL (/api)
 * 
 * This ensures the app works correctly in all deployment scenarios.
 */

// Check if we're running on a custom domain (not Emergent infrastructure)
const isCustomDomain = () => {
  const hostname = window.location.hostname;
  // If hostname is NOT an Emergent domain, it's a custom domain
  return !hostname.includes('.emergentagent.com') && 
         !hostname.includes('.emergent.host') &&
         !hostname.includes('localhost') &&
         !hostname.includes('127.0.0.1');
};

// Get the API base URL
export const getApiUrl = () => {
  // PRIORITY 1: If on custom domain (admin.tmconsultingf.com, etc.), always use relative URL
  // This ensures API calls go to the same domain that serves the frontend
  if (isCustomDomain()) {
    console.log('[API] Using relative URL for custom domain:', window.location.hostname);
    return '/api';
  }
  
  // PRIORITY 2: For Emergent preview/deploy environments, use the env variable
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl.trim() !== '') {
    console.log('[API] Using env URL:', envUrl);
    return `${envUrl}/api`;
  }
  
  // FALLBACK: Use relative URL
  console.log('[API] Using fallback relative URL');
  return '/api';
};

// Export the API URL for use across the app
export const API_URL = getApiUrl();

// Export backend URL for direct access (used for photo URLs etc)
export const getBackendUrl = () => {
  // For custom domains, use same origin
  if (isCustomDomain()) {
    return '';
  }
  
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl.trim() !== '') {
    return envUrl;
  }
  return '';  // Same origin
};

export const BACKEND_URL = getBackendUrl();

// Log the configuration on load
console.log('[API Config] Hostname:', window.location.hostname);
console.log('[API Config] Is Custom Domain:', isCustomDomain());
console.log('[API Config] API_URL:', API_URL);
